export default "127f241871a9fe42.ttf"